import Table from './Table';

export default Table;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/table/index.js